window.lp.ModuleElementPropertiesPanelMethods = {
  hasPropertiesPanel: true,

  getElementPropertiesPanelClass: function() {
    return this.namespace[this.getElementPropertiesPanelClassName()];
  },

  getElementPropertiesPanelClassName: function() {
    return this.elementPropertiesPanelClassName ?
           this.elementPropertiesPanelClassName :
           this.name.replace(/ /g,'') + 'ElementPropertiesPanel';
  },

  getElementPropertiesPanel: function() {
    this.elementPropertiesPanel = this.elementPropertiesPanel || new (this.getElementPropertiesPanelClass())();
    return this.elementPropertiesPanel;
  },

  // Deprecated methods:

  getPropertiesPanel: function() {
    return this.getElementPropertiesPanel();
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/module_element_properties_panel_methods.js
// module id = 419
// module chunks = 0 1